import { render, staticRenderFns } from "./CoursesManagement.vue?vue&type=template&id=dd1b8c7e&"
import script from "./CoursesManagement.vue?vue&type=script&lang=js&"
export * from "./CoursesManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports